@if (this.platform.SAFARI) {
    <object
            [data]="pathPdf | safe"
            width="100%"
            height="100%"
            style="{{style}}"
    >
        <p>
            <b>Example fallback content</b>: This browser does not support PDFs. Please download the PDF to view
            it: <a href="{{ pathPdf }}">Download PDF</a>.
        </p>
    </object>
} @else {
    <object
            [data]="pathPdf | safe"
            type="application/pdf"
            width="100%"
            height="100%"
            style="{{style}}"
    >
        <p>
            <b>Example fallback content</b>: This browser does not support PDFs. Please download the PDF to view
            it: <a href="{{ pathPdf }}">Download PDF</a>.
        </p>
    </object>
}